import { render, staticRenderFns } from "./CoreLayoutHorizontal.vue?vue&type=template&id=d8aba722&"
import script from "./CoreLayoutHorizontal.vue?vue&type=script&lang=js&"
export * from "./CoreLayoutHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./CoreLayoutHorizontal.vue?vue&type=style&index=0&id=d8aba722&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports